import { useTranslation } from 'next-i18next'

interface Props {
  chosenCountry?: string
  countries: string[]
}

export default function CountriesDropdownOptions({ chosenCountry, countries }: Props): React.ReactElement {
  const { t } = useTranslation('settings')

  const shouldShowChooseCountryOption = !chosenCountry || chosenCountry?.trim() === '' || !(countries?.length > 0)

  return (
    <>
      {/* The "Select Country" option will be displayed only if no country has been selected */}
      {shouldShowChooseCountryOption && <option value="">{t('chooseCountry')}</option>}
      {countries?.map((country) => (
        <option key={country} value={country}>
          {country}
        </option>
      ))}
    </>
  )
}
